// Rôle : convertit les préférences venant de l'API (Preferences[]) en Column[].
// Appelé dans setPreferenceReducer et dans useSyncPriceCacheProviderPreferences.
// Lookup map construit depuis DEFAULT_PRICE_CACHE_PROVIDER_COLUMNS : ajouter une colonne = l'ajouter là, c'est tout.

import { Preferences } from '../../profile/objects/preferences';
import {
    DEFAULT_PRICE_CACHE_PROVIDER_COLUMNS,
    EMPTY_PRICE_CACHE_PROVIDER_LIST_CRITERIA,
    PRICE_CACHE_PROVIDER_MODULE
} from '../constant/priceCacheConstant';
import { Column } from '../objects/column';

const COLUMN_MAP: Record<string, Column> = Object.fromEntries(
    DEFAULT_PRICE_CACHE_PROVIDER_COLUMNS.map(col => [col.field_name, col])
);

export const setPriceCacheProviderPreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): { order_by: string; order: 'asc' | 'desc'; columns: Column[]; preferences: Preferences[] } => {
    const seen_field_names: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = EMPTY_PRICE_CACHE_PROVIDER_LIST_CRITERIA.order_by;
    let order: 'asc' | 'desc' = EMPTY_PRICE_CACHE_PROVIDER_LIST_CRITERIA.order;

    new_preferences.forEach((preference: Preferences) => {
        if (preference.module !== PRICE_CACHE_PROVIDER_MODULE) return;
        if (seen_field_names.includes(preference.field_name)) return;

        const col_def = COLUMN_MAP[preference.field_name];
        if (col_def) {
            columns.push({ ...col_def, checked: preference.active, last_updated: false });
            if (preference.ordering_asc !== null) order_by = col_def.order_by;
        }

        preferences.push(preference);
        seen_field_names.push(preference.field_name);
        order = preference.ordering_asc !== null
            ? preference.ordering_asc ? 'asc' : 'desc'
            : order;
    });

    // Compléter avec les colonnes du state non couvertes par les préférences API
    if (columns.length !== state_columns.length) {
        state_columns.forEach(column => {
            if (!columns.some(c => c.field_name === column.field_name)) {
                columns.push({ ...column });
            }
        });
    }

    return { order_by, order, columns, preferences };
};
